if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      this.handleErrorMessage();
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');
      this.submitButton.querySelector('[data-addtocart-text]').classList.add('hidden');
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
      
      }
      config.body = formData;
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);
           
            this.submitButton.setAttribute('aria-disabled', true);
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }
          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          if(document.querySelector('#product-quic-kview')&& document.querySelector('#product-quic-kview').classList.contains("active")){
            document.querySelector('#product-quic-kview').classList.remove("active")
          }
          if(this.cart){
            this.cart.renderContents(response ,true);
            this.cart.classList.add("active");
            document.body.classList.add("no-scroll");
            let cartItemsElement = this.cart.querySelector(".side-drawer-modal-inner");
            setTimeout(function(){
              focusElement == "" && (focusElement =  this.submitButton)
              trapFocusElements(cartItemsElement)
            },1500)
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          this.submitButton.querySelector('[data-addtocart-text]').classList.remove('hidden');
          if (this.cart && this.cart.classList.contains('is-empty'))
          this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
       
        });
    }

    // onSubmitHandler(evt) {
    //   evt.preventDefault();
    //   if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
    //   this.handleErrorMessage();
    //   this.submitButton.setAttribute('aria-disabled', true);
    //   this.submitButton.classList.add('loading');
    //   this.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');
    //   this.submitButton.querySelector('[data-addtocart-text]').classList.add('hidden');
    //   const config = fetchConfig('javascript');
    //   config.headers['X-Requested-With'] = 'XMLHttpRequest';
    //   delete config.headers['Content-Type'];
    //   const formData = new FormData(this.form);
    //   if (this.cart) {
    //     formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
    //     formData.append('sections_url', window.location.pathname);
      
    //   }
    //   config.body = formData;
    //   fetch(`${routes.cart_add_url}`, config)
    //   .then((response) => response.json())
    //   .then((response) => {
    //     if (response.status) {
    //       publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
    //       this.handleErrorMessage(response.description);
    //       this.submitButton.setAttribute('aria-disabled', true);
    //       this.error = true;
    //       return;
    //     } else if (!this.cart) {
    //       window.location = window.routes.cart_url;
    //       return;
    //     }
        
    //     if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
    //     this.error = false;
        
    //     if(document.querySelector('#product-quic-kview')&& document.querySelector('#product-quic-kview').classList.contains("active")){
    //       document.querySelector('#product-quic-kview').classList.remove("active")
    //     }
        
    //     // if(this.cart){
    //     //   this.cart.classList.add("active");
    //     //   document.querySelector("body").classList.add("no-scroll");
          
    //     //   const cartInner = this.cart.querySelector(".side-drawer-modal-inner");
    //     //   if(cartInner) {
    //     //     const loadingOverlay = document.createElement('div');
    //     //     loadingOverlay.className = 'cart-loading-overlay';
    //     //     // loadingOverlay.innerHTML = `
    //     //     //   <div class="cart-loading-spinner">
    //     //     //     <svg class="spinner" viewBox="0 0 50 50">
    //     //     //       <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
    //     //     //     </svg>
    //     //     //     <p>Cart updating...</p>
    //     //     //   </div>
    //     //     // `;
    //     //     cartInner.style.position = 'relative';
    //     //     cartInner.appendChild(loadingOverlay);
    //     //   }
          
    //     //   setTimeout(() => {
    //     //     fetch(this.cart.dataset.url)
    //     //       .then(res => res.text())
    //     //       .then(html => {
    //     //         document.getElementById('minicart').innerHTML = this.cart.getSectionInnerHTML(html, 'minicart');
                
    //     //         if(document.querySelector("#cart-upsell-product")){
    //     //           themeSlidersInit($("#cart-upsell-product"));
    //     //         }
                
    //     //         this.cart.querySelectorAll('[data-sideDrawer-close]').forEach((button) =>
    //     //           button.addEventListener('click', this.cart.closeDrawer.bind(this.cart))
    //     //         );
                
    //     //         let cartItemsElement = this.cart.querySelector(".side-drawer-modal-inner");
    //     //         setTimeout(() => {
    //     //           trapFocusElements(cartItemsElement)
    //     //         }, 500);
                
    //     //         setTimeout(() => {
    //     //           fetch("/cart.js")
    //     //             .then(response => response.json())
    //     //             .then((data) => {
    //     //               let totalprice = data.total_price;
    //     //               const percent = shippingProgressBar(totalprice);
    //     //               console.log(percent);
    //     //             })
    //     //         }, 500);
    //     //       })
    //     //       .catch(e => {
    //     //         console.error(e);
    //     //         const loadingOverlay = this.cart.querySelector('.cart-loading-overlay');
    //     //         if(loadingOverlay) loadingOverlay.remove();
    //     //       });
    //     //   }, 2000);
    //     // }


    //     if(this.cart){

    //       this.cart.renderContents(response);

    //       this.cart.classList.add("active");
    //       document.querySelector("body").classList.add("no-scroll");
          
    //       const cartInner = this.cart.querySelector(".side-drawer-modal-inner");
    //       if(cartInner) {
    //         const loadingOverlay = document.createElement('div');
    //         loadingOverlay.className = 'cart-loading-overlay';
    //         cartInner.style.position = 'relative';
    //         cartInner.appendChild(loadingOverlay);
    //       }
          
    //       setTimeout(() => {
    //         fetch("/cart.js")
    //           .then(response => response.json())
    //           .then((data) => {
    //             let totalprice = data.total_price;
    //             const percent = getShippingProgress(totalprice);
    //             console.log('Shipping progress:', percent);
                
    //             const needCartBotDelay = percent == 100;
    //             const delayTime = needCartBotDelay ? 1500 : 0;
                
    //             console.log('Need CartBot delay:', needCartBotDelay, '- Additional delay:', delayTime);
                
    //             setTimeout(() => {
    //               fetch(this.cart.dataset.url)
    //                 .then(res => res.text())
    //                 .then(html => {
    //                   document.getElementById('minicart').innerHTML = this.cart.getSectionInnerHTML(html, 'minicart');
                      
    //                   if(document.querySelector("#cart-upsell-product")){
    //                     themeSlidersInit($("#cart-upsell-product"));
    //                   }
                      
    //                   this.cart.querySelectorAll('[data-sideDrawer-close]').forEach((button) =>
    //                     button.addEventListener('click', this.cart.closeDrawer.bind(this.cart))
    //                   );
                      
    //                   let cartItemsElement = this.cart.querySelector(".side-drawer-modal-inner");
    //                   setTimeout(() => {
    //                     trapFocusElements(cartItemsElement)
    //                   }, 500);
                      
    //                   shippingProgressBar(totalprice);
    //                 })
    //                 .catch(e => {
    //                   console.error(e);
    //                   const loadingOverlay = this.cart.querySelector('.cart-loading-overlay');
    //                   if(loadingOverlay) loadingOverlay.remove();
    //                 });
    //             }, delayTime);
    //           })
    //           .catch(e => {
    //             console.error('Error checking cart:', e);
    //             setTimeout(() => {
    //               fetch(this.cart.dataset.url)
    //                 .then(res => res.text())
    //                 .then(html => {
    //                   document.getElementById('minicart').innerHTML = this.cart.getSectionInnerHTML(html, 'minicart');
                      
    //                   if(document.querySelector("#cart-upsell-product")){
    //                     themeSlidersInit($("#cart-upsell-product"));
    //                   }
                      
    //                   this.cart.querySelectorAll('[data-sideDrawer-close]').forEach((button) =>
    //                     button.addEventListener('click', this.cart.closeDrawer.bind(this.cart))
    //                   );
                      
    //                   let cartItemsElement = this.cart.querySelector(".side-drawer-modal-inner");
    //                   setTimeout(() => {
    //                     trapFocusElements(cartItemsElement)
    //                   }, 500);
    //                 })
    //                 .catch(e => {
    //                   console.error(e);
    //                   const loadingOverlay = this.cart.querySelector('.cart-loading-overlay');
    //                   if(loadingOverlay) loadingOverlay.remove();
    //                 });
    //             }, 1500);
    //           });
    //       }, 500);
    //     }


        
    //   })
    //   .catch((e) => {
    //     console.error(e);
    //   })
    //   .finally(() => {
    //     this.submitButton.classList.remove('loading');
    //     this.submitButton.querySelector('[data-addtocart-text]').classList.remove('hidden');
    //     if (this.cart && this.cart.classList.contains('is-empty'))
    //       this.cart.classList.remove('is-empty');
    //     if (!this.error) this.submitButton.removeAttribute('aria-disabled');
    //     this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
    //   });
    // }

    handleErrorMessage(errorMessage = false) {
     if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}